import React, { useEffect, useRef } from "react";
import JsBarcode from "jsbarcode";

/**
 * Renders an EAN-13 (or generic) barcode.
 * props: value, height, width (bar width), displayValue, fontSize
 */
export default function Barcode({
  value,
  height = 50,
  width = 1.6,
  displayValue = true,
  fontSize = 14,
  background = "#ffffff",
  lineColor = "#09090B",
  margin = 4,
  format,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current || !value) return;
    try {
      const fmt = format || (/^\d{13}$/.test(value) ? "EAN13" : "CODE128");
      JsBarcode(ref.current, String(value), {
        format: fmt,
        height,
        width,
        displayValue,
        fontSize,
        background,
        lineColor,
        margin,
        font: "JetBrains Mono",
      });
    } catch (e) {
      // fallback to CODE128
      try {
        JsBarcode(ref.current, String(value), {
          format: "CODE128",
          height,
          width,
          displayValue,
          fontSize,
          background,
          lineColor,
          margin,
        });
      } catch (_) {}
    }
  }, [value, height, width, displayValue, fontSize, background, lineColor, margin, format]);

  return <svg ref={ref} data-testid="barcode-svg" />;
}
